/**
 * Pill-style control for a single RMA quick-filter chip on the redesigned list page.
 */
import FontBody3 from "../../../../../../../../../components/fonts/font-body3/font-body3";
import "./rma-list-status-filter-chip.scss";

interface IProps {
    title: string;
    isSelected: boolean;
    disabled?: boolean;
    onClick: () => void;
}

const RmaListStatusFilterChip: React.FC<IProps> = ({ title, isSelected, disabled, onClick }) => {
    return (
        <div
            role="button"
            tabIndex={disabled ? -1 : 0}
            onClick={disabled ? undefined : onClick}
            onKeyDown={(e) => {
                if (disabled) {
                    return;
                }
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onClick();
                }
            }}
            className={`rma-list-status-filter-chip ${isSelected ? "selected" : ""} ${disabled ? "disabled" : ""}`}
        >
            <FontBody3>{title}</FontBody3>
        </div>
    );
};

export default RmaListStatusFilterChip;
